import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'

export const colors = {
  // Core brand colors
  brandAqua: '#1F7F89',
  aqua100: '#07565E',
  aqua200: '#CCF2F7',
  aqua300: '#B8E3E9',
  aqua400: '#7EC8D0',
  aqua500: '#33A9B5',
  aqua600: '#1F7F89',
  aqua700: '#11626A',
  aqua800: '#035058',
  navyblue: '#33A9B5',

  // Design System v3 colors
  aquaMain0: '#032C30',
  aquaMain10: '#064147',
  aquaMain20: '#035058',
  aquaMain30: '#11626A',
  aquaMain40: '#1F7F89',
  aquaMain50: '#33A9B5',
  aquaMain55: '#40BCC9',
  aquaMain60: '#2BC8D8',
  aquaMain70: '#71D7E1',
  aquaMain80: '#9FE2E9',
  aquaMain90: '#B9F1F6',
  aquaMain95: '#E2F9FC',
  aquaMain99: '#F5FEFF',

  // Neutral colors
  white: '#FFF',
  gray50: '#F9F9FB',
  gray75: '#F3F5F9',
  gray100: '#E4E7EA',
  gray200: '#CCD2D8',
  gray300: '#9BA4AE',
  gray400: '#7D8793',
  gray500: '#646D7B',
  gray600: '#54606C',
  gray700: '#414B57',
  gray800: '#343E49',
  gray900: '#202832',

  // Secondary colors
  salmonNeutral: '#F9A287',
  salmonDark: '#E27958',
  salmonLight: '#FFEEE9',

  cyanNeutral: '#53A7E2',
  cyanDark: '#2278B5',
  cyanLight: '#D8EFFF',

  yellowNeutral: '#E2A14A',
  yellowDark: '#C17930',
  yellowLight: '#FFE5C2',

  lavenderNeutral: '#9C82D6',
  lavenderDark: '#664AA6',
  lavenderLight: '#F3EFFF',

  greenNeutral: '#69BF4A',
  greenDark: '#418B26',
  greenLight: '#D6F3CC',

  // Other colors
  grayedwhite: 'rgba(255, 255, 255, 0.6)',
  lightGrey: 'rgba(0, 0, 0, 0.45)',
  borderGrey: '#CCD2D8',
  black: '#505050',
  chipBackground: 'rgba(0, 0, 0, 0.12)',
  background: 'rgba(0, 0, 0, 0.09)',
  lightCyan: 'rgb(235, 246, 247)',
  maximumBlueGreen: '#42B6BE',
  caption: 'rgba(0, 0, 0, 0.38)',
  darkenBlueGreen: 'rgb(15, 63, 68)',
  orangePeel: '#F99F32',
  blueNCS: '#1A82B5',
  mantis: '#69BF4A',
  begonia: '#F57272',
  blueGray100: '#486384',
  blueTertiary50: '#3B4E65',
}

export const themeConfig = {
  palette: {
    primary: { main: colors.brandAqua },
    secondary: { main: colors.white },
    text: {
      secondary: colors.gray900,
    },
    background: {
      default: colors.gray50,
    },
  },
  typography: {
    useNextVariants: true,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    fontWeightBold: 500,
    h1: {
      fontSize: 64,
      fontWeight: 900,
    },
    h2: {
      fontSize: 46,
      letterSpacing: 0.35,
      fontWeight: 700,
    },
    h3: {
      fontSize: 40,
    },
    h4: {
      fontSize: '36px',
      letterSpacing: '0.25px',
      fontWeight: 700,
      lineHeight: '1.176',
    },
    h5: {
      fontSize: '28px',
      fontWeight: 500,
      lineHeight: '1.16',
    },
    h6: {
      fontSize: 22,
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
      lineHeight: '1.43',
      letterSpacing: '0.25px',
    },
    subtitle1: {
      fontSize: '16px',
      lineHeight: '1.5',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '1.75',
      letterSpacing: '4px',
      textTransform: 'uppercase',
    },
    overline: {
      fontSize: '12px',
      lineHeight: '1.33',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },
    caption: {
      fontSize: '12px',
      lineHeight: '1.33',
      letterSpacing: '0.4px',
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: colors.white,
        backgroundColor: colors.brandAqua,
      },
      containedSecondary: {
        color: colors.brandAqua,
        backgroundColor: colors.white,
        '&:hover': {
          color: colors.white,
          backgroundColor: colors.brandAqua,
        },
      },
      contained: {
        color: colors.brandAqua,
        backgroundColor: colors.white,
      },
      outlined: {
        color: colors.white,
        borderColor: colors.white,
      },
    },
    MuiChip: {
      root: {
        backgroundColor: colors.chipBackground,
        borderRadius: '4px',
      },
    },
    MuiLink: {
      root: {
        cursor: 'pointer',
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: colors.gray50,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: `1px solid ${colors.gray50}`,
        padding: '8px 40px',
      },
      body: {
        color: colors.gray900,
        padding: '32px 40px',
        fontSize: '14px',
        lineHeight: '1.43',
        letterSpacing: '0.25px',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: '16px',
        lineHeight: '1.5',
        letterSpacing: '0.15px',
        color: colors.gray900,
      },
    },
  },
}

export default responsiveFontSizes(createMuiTheme(themeConfig))
